import { render, staticRenderFns } from "./phoneNumberCode.vue?vue&type=template&id=daba3bd2&scoped=true&"
import script from "./phoneNumberCode.vue?vue&type=script&lang=js&"
export * from "./phoneNumberCode.vue?vue&type=script&lang=js&"
import style0 from "./phoneNumberCode.vue?vue&type=style&index=0&id=daba3bd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daba3bd2",
  null
  
)

export default component.exports